/*
 * Supply6 fix (2026-08-28) - product media gallery video / carousel lock.
 *
 * Focal's <product-media> element disables Flickity dragging as soon as a gallery
 * video starts:
 *
 *     mainCarousel.addEventListener('video:played', () => mainCarousel.setDraggable(false));
 *     mainCarousel.addEventListener('video:paused', () => mainCarousel.setDraggable(true));
 *
 * Two consequences on the PDPs that have a VIDEO in the product media gallery
 * (currently only Fibre+ and Plant Protein):
 *
 *   1. While the video plays the gallery cannot be swiped/dragged at all. With
 *      `enable_video_autoplay` on, the video starts by itself the moment the
 *      shopper swipes onto that slide, so they get stuck on it.
 *   2. A <video> that plays to the end fires `ended`, never `pause`, so
 *      `video:paused` never fires and the gallery stays permanently
 *      un-draggable for the rest of the page view.
 *
 * This restores dragging while the video plays and again when it ends.
 * It is scoped to the product media carousel and touches nothing else.
 */
(function () {
  var SELECTOR = 'flickity-carousel.product__media-list';

  function restoreDragging(carousel) {
    if (carousel && typeof carousel.setDraggable === 'function') {
      carousel.setDraggable(true);
    }
  }

  function carouselFor(node) {
    return node && node.closest ? node.closest(SELECTOR) : null;
  }

  // `video:played` is dispatched by <native-video> and bubbles up to the carousel.
  // Focal disables dragging on the same event and setDraggable() is async, so
  // re-apply just after it has settled.
  document.addEventListener('video:played', function (event) {
    var carousel = carouselFor(event.target);

    if (!carousel) {
      return;
    }

    setTimeout(function () { restoreDragging(carousel); }, 60);
    setTimeout(function () { restoreDragging(carousel); }, 400);
  }, true);

  // `ended` does not bubble, but it does propagate through the capture phase.
  document.addEventListener('ended', function (event) {
    var target = event.target;

    if (!target || target.tagName !== 'VIDEO') {
      return;
    }

    restoreDragging(carouselFor(target));
  }, true);
})();
